import { styled } from "goober";
import { Text } from "./Text";

const Pill = styled("div")`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  gap: 4px;
  background: var(--surface-primary);
  border: 0.5px solid var(--border-alpha);
  border-radius: 16px;
  width: fit-content;
`;

const Dot = styled("div")`
  position: relative;
  width: 12px;
  height: 12px;

  &::before {
    content: "";
    position: absolute;
    inset: 1px;
    border-radius: 10px;
    background: var(--dot-400);
  }

  &::after {
    content: "";
    position: absolute;
    inset: 3px;
    border-radius: 10px;
    background: var(--dot-600);
  }
`;

type Props = {
  enabled: boolean;
};

export function SkillStatusPill({ enabled }: Props) {
  const color = enabled ? "green" : "gray";
  return (
    <Pill>
      <Dot
        style={
          {
            "--dot-400": `var(--${color}-400)`,
            "--dot-600": `var(--${color}-600)`,
          } as React.CSSProperties
        }
      />
      <Text variant="text-small-md" color="var(--text-primary)">
        {enabled ? "Enabled" : "Disabled"}
      </Text>
    </Pill>
  );
}
